import { Amplify } from 'aws-amplify';

export type CognitoConfig = {
	clientId: string;
	domain: string;
	region: string;
	userPoolId: string;
};

const clientId = import.meta.env.CE_COGNITO_CLIENT_ID;
const domain = import.meta.env.CE_COGNITO_DOMAIN;
const region = import.meta.env.CE_COGNITO_REGION;
const userPoolId = import.meta.env.CE_COGNITO_USER_POOL_ID;

const config: CognitoConfig = {
	clientId,
	domain,
	region,
	userPoolId
};

export function setupAuth(): any {
	Amplify.configure({
		Auth: {
			Cognito: {
				//  Amazon Cognito User Pool ID
				userPoolId: config.userPoolId,
				// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
				userPoolClientId: config.clientId,
				// 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
				signUpVerificationMethod: 'code', // 'code' | 'link'
				loginWith: {
					// OPTIONAL - Hosted UI configuration
					oauth: {
						responseType: 'code',
						scopes: ['phone', 'email', 'profile', 'openid'],
						domain: config.domain,
						redirectSignIn: [origin],
						redirectSignOut: [origin]
					}
				}
			}
		}
	});
}
